/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from "./../../base/colors";
import typography from "./../../base/typography";
import borders from "./../../base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "./../../functions/pxToRem";

const { dark, white, grey, inputColors } = colors;
const { size, fontWeightRegular } = typography;
const { borderWidth, borderRadius } = borders;

export default {
    styleOverrides: {
        root: {
            '&:focus': {
                borderWidth: '2px'
            },
            borderRadius: `${borderRadius.input} !important`,
            color: `${grey[700]} !important`,
            padding: ' 0  8px 4px 8px !important',
            '& fieldset': {
                borderColor: 'transparent'
            },
            '& legend': {
                display: 'none',
            },
            background: '#EEF0F9',
        },

        input: {
            padding: '12px 4px !important',
            width: "100% !important",
            //background: '#EEF0F9',

            "&::-webkit-input-placeholder": {
                color: `${dark.main} !important`
            }
        }
    }
};
